<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
export default {
}
</script>
<style type="text/css">
.centerDiv{
  display: flex;
  align-items: center;
  justify-content: center;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background:rgba(230, 230, 230,0.2);
}

::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}
/* ::-webkit-scrollbar{
  overflow:unset;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue